"use client";
import { jsx as o } from "react/jsx-runtime";
import { useState as r, createContext as u, useContext as s } from "react";
const n = u(void 0);
function c() {
  const [e, t] = r(!1);
  return { open: e, setOpen: t };
}
const l = ({ children: e, value: t }) => /* @__PURE__ */ o(n.Provider, { value: t, children: e }), x = () => {
  const e = s(n);
  if (!e)
    throw new Error("useHelpMenu must be used within a HelpMenuProvider");
  return e;
};
export {
  l as HelpMenuProvider,
  x as useHelpMenu,
  c as useHelpMenuState
};
